<template>
    <!-- Bilesenin cevreledigi alanin ustune, veri gelene kadar gorunen yumusak overlay.
         "wrapper" moduyla mevcut bir div'in icinde absolute konumlanir; "fixed" moduyla
         sayfa tamami kaplanir. Wrapper mod tercih edilir cunku modal ustunde de gorunmez. -->
    <transition name="v-overlay-fade">
        <div v-if="loading" class="v-overlay" :class="{ 'v-overlay--fixed': fixed }">
            <div class="v-overlay__box">
                <img
                    :src="logo"
                    class="v-overlay__logo"
                    alt="Vişne Madencilik"/>
                <div class="v-overlay__spinner">
                    <div class="effect-1"></div>
                    <div class="effect-2"></div>
                    <div class="effect-3"></div>
                </div>
                <div v-if="text" class="v-overlay__text">{{ text }}</div>
            </div>
        </div>
    </transition>
</template>

<script>
import logo from '@/assets/images/logo/ozturelogo.png'

export default {
    name: 'VOverlayLoader',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: 'Yükleniyor...'
        },
        // wrapper (default): parent div'in icinde absolute; fixed: tum sayfa.
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return { logo }
    }
}
</script>

<style lang="scss" scoped>
$brand-primary: #0F3D91;

.v-overlay {
    position: absolute;
    inset: 0;
    background: rgba(248, 249, 251, 0.88);
    backdrop-filter: blur(2px);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
}

.v-overlay--fixed {
    position: fixed;
}

.v-overlay__box {
    text-align: center;
    padding: 1.5rem 2rem;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(15, 61, 145, 0.12);
    border: 1px solid rgba(15, 61, 145, 0.08);
    min-width: 200px;
}

.v-overlay__logo {
    max-width: 140px;
    height: auto;
    display: block;
    margin: 0 auto 0.5rem;
    opacity: 0.9;
}

.v-overlay__spinner {
    position: relative;
    width: 42px;
    height: 42px;
    margin: 0.5rem auto;
}

.v-overlay__spinner .effect-1,
.v-overlay__spinner .effect-2,
.v-overlay__spinner .effect-3 {
    position: absolute;
    inset: 0;
    border: 3px solid transparent;
    border-left-color: $brand-primary;
    border-radius: 50%;
    box-sizing: border-box;
}

.v-overlay__spinner .effect-1 { animation: v-overlay-rotate 1s ease infinite; }
.v-overlay__spinner .effect-2 { animation: v-overlay-rotate 1s ease infinite 0.1s; opacity: 0.65; }
.v-overlay__spinner .effect-3 { animation: v-overlay-rotate 1s ease infinite 0.2s; opacity: 0.35; }

.v-overlay__text {
    margin-top: 0.5rem;
    color: $brand-primary;
    font-weight: 500;
    font-size: 0.9rem;
}

.v-overlay-fade-enter-active,
.v-overlay-fade-leave-active {
    transition: opacity 0.18s ease;
}
.v-overlay-fade-enter,
.v-overlay-fade-leave-to {
    opacity: 0;
}

@keyframes v-overlay-rotate {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
